import { ILandingPreference } from '@/interfaces';
import { defineStore } from 'pinia';
import { now } from 'common/utils/date.utils';

export interface ILandingPreferenceState {
  preferenceByUserTenantKey: Record<string, ILandingPreference | undefined>;
}

const getPreferenceKey = (userId: number, tenantId: number): string => `${userId}:${tenantId}`;

export const useLandingPreferenceStore = defineStore('landingPreference', {
  actions: {
    setAdminContext(userId: number, tenantId: number): void {
      const key = getPreferenceKey(userId, tenantId);
      this.$patch((state) => {
        state.preferenceByUserTenantKey[key] = {
          classId: null,
          context: 'admin',
          updatedAt: now().toISOString(),
        };
      });
    },

    setClassContext(userId: number, tenantId: number, classId: number | null): void {
      const key = getPreferenceKey(userId, tenantId);
      this.$patch((state) => {
        state.preferenceByUserTenantKey[key] = {
          classId,
          context: 'class',
          updatedAt: now().toISOString(),
        };
      });
    },
  },

  getters: {
    getPreference: (state) => {
      return (userId?: number | null, tenantId?: number | null): ILandingPreference | null => {
        if (!userId || !tenantId) return null;
        const key = getPreferenceKey(userId, tenantId);
        return state.preferenceByUserTenantKey[key] ?? null;
      };
    },
  },

  state: (): ILandingPreferenceState => ({
    preferenceByUserTenantKey: {},
  }),

  persist: true,
});
